import React from 'react'
import {Component} from 'react'
import {DateTime} from 'luxon'
import View from './view'

export default class Location extends Component {
  get heading(){
    const extrasHeading = this.props.locationExtras !== undefined ? this.props.locationExtras.heroHeading : false
    const locationName  = this.props.location.name
    return extrasHeading ? extrasHeading : locationName
  }
  get program(){
    const event = this.props.event
    if( ! event ) return null
    let program = false
    let date = DateTime.fromString( event.date, 'yyyy-M-d' )
    date = date.toFormat('yyyy-MM-dd')
    if(
      typeof this.props.locationExtras.specialPrograms[ date ] !== 'undefined'
    ){
      program = this.props.locationExtras.specialPrograms[ date ]
    }
    return program
  }
  render (){
    const { setEvent, event } = this.props
    const extras = this.props.locationExtras
    const aboutCTA = extras ? extras.aboutCTA : false
    let vendors = []
    if (event !== undefined) {
      vendors = Object.values(Object.groupBy([...event.vendors, ...event.creators], 
        ({ id }) => id)).map(e => e.reduce((acc, cur) => ({ ...acc, ...cur }))
      );
    }
    return (
      <View
        location={ this.props.location }
        aboutCTA={ aboutCTA }
        heading={ this.heading }
        setEvent={ setEvent }
        event={ event }
        vendors={vendors}
        program={ this.program }
      />
    )
  }
}
